export const PAGES = {
  landing: '/',
  home: '/home',
};
